var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { UtilService } from '@app/utility/util.service';
import { ApiService } from '@app/utility/api.service';
import { MasterService } from '@app/utility/master.service';
import { Router } from "@angular/router";
import { TranslateService } from '@ngx-translate/core';
var TestndidComponent = /** @class */ (function () {
    function TestndidComponent(Api, Util, MasterService, router, translate) {
        this.Api = Api;
        this.Util = Util;
        this.MasterService = MasterService;
        this.router = router;
        this.translate = translate;
        this.Editable = false;
        this.FileList = [];
        this.DocumentList = [];
        this.TotalFileSize = 0;
        this.InvestigateFlag = false;
        this.AppealFlag = false;
        this.OTPRefCode = "";
        this.ElapseTime = 0;
        this.TotalTime = 0;
        this.menuEnabled = false;
        this.drosWeb = "";
        this.PathPdf = "";
    }
    TestndidComponent.prototype.ngOnInit = function () {
        this.PortalUser = JSON.parse(localStorage.getItem("dpa_portal"));
        $('#dpa_contact_id').val(this.PortalUser.contactid);
    };
    TestndidComponent.prototype.InvestigateAndAppealStatus = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.router.navigate(["singlegatewaywait"]);
                return [2 /*return*/];
            });
        });
    };
    TestndidComponent.prototype.InvestigateAndAppealCondition = function (UID) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.Util.IsNullOrUndefined(UID)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.Api.postCustomApi("SingleGateway", "GetRefID", { UID: UID })];
                    case 1:
                        result = _a.sent();
                        if (!this.Util.IsNullOrUndefined(result) && result.length > 0) {
                            if (!this.Util.IsNullOrUndefined(result[0].authorizationUrl)) {
                                this.drosWeb = result[0].authorizationUrl;
                                $("#btnInvestigate").removeClass("sr-only");
                            }
                            else {
                                $("#btnInvestigate").addClass("sr-only");
                            }
                        }
                        else {
                            $("#btnInvestigate").addClass("sr-only");
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        $("#btnInvestigate").addClass("sr-only");
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    TestndidComponent.prototype.CreateTable1 = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.router.navigate(["mainmenu/singlegatewaywait"]);
                return [2 /*return*/];
            });
        });
    };
    TestndidComponent.prototype.OpenNDID = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/];
            });
        });
    };
    return TestndidComponent;
}());
export { TestndidComponent };



// WEBPACK FOOTER //
// ./src/app/testndid/testndid.component.ts.pre-build-optimizer.js